import { render, staticRenderFns } from "../templates/normal_fcont_180.html?vue&type=template&id=53adbc2a&scoped=true&"
import script from "./normal_fcont_180.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_180.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53adbc2a",
  null
  
)

export default component.exports